<template>
  <div class="box" v-if="employee">
    <p>
      Redni broj vozila: <b>{{ vehicleId }}</b>
    </p>
    <p>
      Model: <b>{{ Model }}</b>
    </p>
    <p>
      Tablice: <b>{{ licensePlate }}</b>
    </p>
    <p>
      Vozilo duži: <b>{{ employee.name }}</b>
    </p>
  </div>
</template>

<script>
export default {
  name: "VehicleInfo",

  props: {
    vehicleId: Number,
    employeeId: Number,
    licensePlate: String,
    Model: String,
  },

  watch: {
    employeeId: function (newVal, oldVal) {
      // watch it
      console.log("Prop changed: ", newVal, " | was: ", oldVal);

      this.prepare();
    },
  },

  data() {
    return {
      employee: null,
    };
  },

  mounted() {
    this.prepare();
  },

  methods: {
    prepare() {
      this.employee = this.$store.state.general.employees.find(
        (e) => e.id === this.employeeId
      );
    },
  },
};
</script>
